<template>
  <v-text-field
    v-model="textQuery"
    v-tooltip="$t('components.TextFilter.searchTip')"
    class="mr-3"
    :rules="rules.minChar"
    prepend-icon="mdi-text-search"
    :label="$t('components.TextFilter.label.search')"
  />
</template>

<script>

export default {
  name: 'TextQueryFilter',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      rules: {
        minChar: [v => (v && v.length >= 2) || this.$t('components.TextFilter.label.rule')],
      },
    };
  },
  computed: {
    textQuery: {
      get() {
        if (this.value && this.value.value) {
          return this.value.value;
        }

        return [];
      },
      set(newValue) {
        if (!newValue || newValue.length === 0) {
          return this.$emit('input', undefined);
        }

        this.$emit('input', {
          value: newValue,
        });
      },
    },
  },
};
</script>
